import { DeepPartial } from "@towersystems/roam-common/lib/shared-types";
import { BaseResponse } from "./base-response";

export class PosApiResponse extends BaseResponse {
  constructor(input?: DeepPartial<PosApiResponse>) {
    super(input);
    if (!this.PurchaseAnalysisData) {
      this.PurchaseAnalysisData = {};
    }
  }

  // Type of API response
  public ResponseType: ResponseType;

  // Additional data to be sent or received directly from the PIN pad
  public PurchaseAnalysisData: { [key: string]: string };
}
